import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const WorkshopImages = ({ block }) => {
  if (!block) return '';
  const { primary } = block;
  const [currentIndex, setCurrentIndex] = useState(0);
  const backgroundColor = primary.background_color;

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % block.items.length);
  };

  const prevImage = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + block.items.length) % block.items.length,
    );
  };

  const getVisibleImages = () => {
    const visibleImages = [];
    for (let i = -2; i <= 2; i++) {
      visibleImages.push(
        block.items[
          (currentIndex + i + block.items.length) % block.items.length
        ],
      );
    }
    return visibleImages;
  };

  const handleAuthorClick = () => {
    window.open(`${block.items[currentIndex].design_link.url}`, '_blank');
  };

  return (
    <>
      <div className="carousel">
        <h2 className="carousel-title">{primary.workshop_title}</h2>
        <div className="carousel-images-container">
          <div className="carousel-images">
            {getVisibleImages().map((image, index) => (
              <div
                key={index}
                className={`carousel-image ${
                  index === 2 ? 'active' : 'inactive'
                }`}
              >
                <img src={image.image.url} alt={image.designer} />
              </div>
            ))}
          </div>
        </div>
        <div className="carousel-controls">
          <button className="carousel-button prev" onClick={prevImage}>
            <img
              src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/Vector_1.png?v=1722609719"
              alt="prev"
            />
          </button>
          <div
            className="carousel-author"
            onClick={handleAuthorClick}
          >
            <AnimatePresence mode="wait">
              <motion.div
                key={currentIndex}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.2 }}
              >
                {block.items[currentIndex].designer}
              </motion.div>
            </AnimatePresence>
          </div>
          <button className="carousel-button next" onClick={nextImage}>
            <img
              src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/Vector_1_1.png?v=1722609744"
              alt="next"
            />
          </button>
        </div>
      </div>
      <style jsx>{`
        .carousel {
          margin: 50px 0 150px;
          position: relative;
          text-align: center;
          overflow: hidden;
          transition: all 0.3s;
          background-color: ${backgroundColor ? backgroundColor : '#000000'};
        }
        .carousel-title {
          color: #e4e4e4;
          font-family: 'big_noodle_titling';
          font-size: 64px;
          letter-spacing: 0;
          margin: 0;
          margin-bottom: 70px;
          padding-bottom: 12px;
        }
        .carousel-images-container {
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
        }
        .carousel-images {
          margin: 50px 0;
          display: flex;
          gap: 80px;
          transition: transform 0.5s ease-in-out;
        }
        .carousel-image {
          flex: 0 0 auto;
          width: 350px;
          height: 250px;
          transition:
            transform 0.5s ease-in-out,
            filter 0.5s ease-in-out;
        }
        .carousel-image img {
          width: 350px;
          height: 250px;
          border-radius: 10px;
        }
        .carousel-image.active {
          margin: 0 40px;
          transform: scaleY(1.4) scaleX(1.33);
          filter: blur(0);
          z-index: 1;
        }
        .carousel-image.inactive {
          transform: scale(1);
          filter: blur(2px);
          opacity: 0.7;
          z-index: 0;
        }
        .carousel-controls {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
        }
        .carousel-author {
          width: 600px;
          font-size: 48px;
          font-weight: 250;
          color: white;
          margin: 40px 20px;
          transition:
            color 0.2s ease-in-out,
            opacity 0.5s ease-in-out,
            transform 0.5s ease-in-out;
          cursor: pointer;
        }
        .carousel-author:hover {
          color: red;
        }
        .carousel-button {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 10px;
          background-color: transparent;
          border: none;
          width: 50px;
          height: 50px;
          cursor: pointer;
          z-index: 2;
          border-radius: 50%;
          border: solid 2px #fff;
        }
        .carousel-button img {
          height: 25px;
          width: 18px;
        }
        .carousel-button.prev {
          margin-right: 10px;
        }
        .carousel-button.next {
          margin-left: 10px;
        }
      `}</style>
    </>
  );
};

export default WorkshopImages;
